import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Products from './pages/Products';
import ProductDetail from './pages/ProductDetail';
import About from './pages/About';
import Recipes from './pages/Recipes';
import Cart from './pages/Cart';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Terms from './pages/Terms';
import RefundPolicy from './pages/RefundPolicy';
import ShippingPolicy from './pages/ShippingPolicy';
import AdminOrders from './pages/AdminOrders';
import FAQ from './pages/FAQ';
import Contact from './pages/Contact';
import Collaborate from './pages/Collaborate';
import OrderTracking from './pages/OrderTracking';
import ReviewForm from './pages/ReviewForm';
import PlannerHome from './planner/PlannerHome';
import PlannerPage from './planner/PlannerPage';
import ChatWidget from './components/ChatWidget';
import './App.css';

const AppShell = () => {
  const location = useLocation();
  const isPlanner = location.pathname.startsWith('/planner');
  return (
    <>
      {!isPlanner && <Header />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/products" element={<Products />} />
        <Route path="/product/:id" element={<ProductDetail />} />
        <Route path="/about" element={<About />} />
        <Route path="/recipes" element={<Recipes />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
        <Route path="/shipping-policy" element={<ShippingPolicy />} />
        <Route path="/admin/orders" element={<AdminOrders />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/collaborate" element={<Collaborate />} />
        <Route path="/track-order" element={<OrderTracking />} />
        <Route path="/review" element={<ReviewForm />} />
        <Route path="/planner" element={<PlannerHome />} />
        <Route path="/planner/:plannerId" element={<PlannerPage />} />
      </Routes>
      {!isPlanner && <Footer />}
      {!isPlanner && !location.pathname.startsWith('/admin') && <ChatWidget />}
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppShell />
      </BrowserRouter>
    </div>
  );
}

export default App;
